var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main-info"},[_c('ul',_vm._l((_vm.main),function(item){return _c('li',{key:item.index},[_c('span',{class:{ 'text-muted': _vm.fetchingMainData }},[_vm._v(_vm._s(item.value))]),_c('span',{class:{ 'text-muted': _vm.fetchingMainData }},[_vm._v(_vm._s(item.description))]),(_vm.fetchingMainData)?_c('c-spinner'):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }